// extracted by mini-css-extract-plugin
module.exports = {"dateTime":"sidebar-date-time_dateTime__60h3Z","time":"sidebar-date-time_time__1GEKy","date":"sidebar-date-time_date__1kxF2"};